module.exports = __webpack_public_path__ + "media/assets/images/tour/1a_Tour_5-3f3a55dcc7bd5b76084be0af3ba338d5.png";